import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=6656677e&scoped=true&"
import script from "./MessagesList.vue?vue&type=script&lang=js&"
export * from "./MessagesList.vue?vue&type=script&lang=js&"
import style0 from "./MessagesList.vue?vue&type=style&index=0&id=6656677e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6656677e",
  null
  
)

/* custom blocks */
import block0 from "./MessagesList.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports